import { API_FRESH_MANDATORY_BARCODE } from 'utils/constants'
import Api from './axiosInstance'

const { LIST, IMPORT } = API_FRESH_MANDATORY_BARCODE

type FetchParams = {
  limit: number
  page: number
  search?: string
  storeCode?: string
}

export type FreshMandatoryBarcode = {
  _id: string
  catalogue: string
  storeCode: string
  createdAt?: string
  updatedAt?: string
}

// One row per barcode PER STORE - a barcode mandatory at three stores shows
// three times, matching exactly what the nightly cron acts on.
const fetchFreshMandatoryBarcodes = ({
  limit,
  page,
  search,
  storeCode,
}: FetchParams) => {
  const options: Record<string, string> = {}
  if (search) options.search = search
  if (storeCode) options.storeCode = storeCode

  const params = new URLSearchParams({
    limit: String(limit),
    page: String(page),
    ...options,
  })

  return Api.get({ url: `${LIST}?${params}` })
}

// Chunked multipart upload - the server reassembles the file, pushes it to S3
// and queues it, so this returns as soon as the upload is accepted, not when
// the import has finished.
const importFreshMandatoryBarcodes = async (data: any) => {
  return Api.post({
    url: IMPORT,
    data,
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

export { fetchFreshMandatoryBarcodes, importFreshMandatoryBarcodes }
